export default __webpack_public_path__ + "static/media/trondo.9252601e.png";